import QuadrantV3 from './QuadrantV3';
import ParameterErrors from '../../../errors/ParameterErrors';
const { throwNotProvided } = ParameterErrors;
const XYZ_FROM_JSON_KEY='f',
	XYZ_QUADRANTS_JSON_KEY='q',
	SCENE_SIZE_JSON_KEY='s',
    PITCH_FROM_REST_IN_SINGLE_QUADRANT_RADIANS='pitchFromRestInSingleQuadrantRadians',
    PITCH_TO_REST_IN_SINGLE_QUADRANT_RADIANS='pitchToRestInSingleQuadrantRadians';
export default class QuadrantsV3{
	constructor({xYZFrom, sceneSize,  xYZQuadrants}){
		this._xYZFrom = xYZFrom;
		this._sceneSize = sceneSize;
		this._xYZQuadrants = xYZQuadrants; 
		this._xLength = this._xYZQuadrants.length;
		this._yLength = this._xYZQuadrants[0].length;
		this._zLength = this._xYZQuadrants[0][0].length;
	}
	get xYZFrom(){
		return this._xYZFrom;
	}
	get sceneSize(){
		return this._sceneSize;
	}
	getObjectIds({yawRadians, pitchRadians, x, y, z, reasonsOut}){
		const proportionX = (x - this._xYZFrom[0])/this._sceneSize[0], 
			proportionY = (y - this._xYZFrom[1])/this._sceneSize[1], 
			proportionZ = (z - this._xYZFrom[2])/this._sceneSize[2];
		let xIndex=Math.floor(this._xLength*proportionX);
		let yIndex=Math.floor(this._yLength*proportionY);
		let zIndex=Math.floor(this._zLength*proportionZ);
		if(xIndex<0)
			xIndex=0;
		else {
			if(xIndex>=this._xLength)
				xIndex=this._xLength-1;
		}
		if(yIndex<0)
			yIndex=0;
		else {
			if(yIndex>=this._yLength)
				yIndex=this._yLength-1;
		}
		if(zIndex<0)
			zIndex=0;
		else {
			if(zIndex>=this._zLength)
				zIndex=this._zLength-1;
		}
		return this._xYZQuadrants[xIndex][yIndex][zIndex].getObjectIds({yawRadians, pitchRadians, reasonsOut});
	}
	static fromJSON(jObject){
		const xYZFrom = jObject[XYZ_FROM_JSON_KEY];
		const sceneSize = jObject[SCENE_SIZE_JSON_KEY];
		const pitchFromRestInSingleQuadrantRadians=jObject[PITCH_FROM_REST_IN_SINGLE_QUADRANT_RADIANS];
		const pitchToRestInSingleQuadrantRadians=jObject[PITCH_TO_REST_IN_SINGLE_QUADRANT_RADIANS];
		const xYZQuadrants = 
			jObject[XYZ_QUADRANTS_JSON_KEY]
			.map(yZQuadrantJArray=>
				yZQuadrantJArray
				.map(zQuadrantJArray=>
					zQuadrantJArray.map(quadrantJObject=>
						QuadrantV3.fromJSON(quadrantJObject, pitchFromRestInSingleQuadrantRadians, pitchToRestInSingleQuadrantRadians)
					)
				)
			);
		return new QuadrantsV3({xYZFrom, sceneSize,
			xYZQuadrants});
	}
}